import { useParams } from "react-router-dom";
import TestSiteList from "./List.jsx";
import TestSiteDetail from "./Detail.jsx";

const TestSitePage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? TestSiteDetail : TestSiteList;

    return <Specified />;
};

export default TestSitePage;
